<template>
  <div class="">
    <div class="home-img">
      <img src="../../assets/home.png" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
export default {
  name: "Home",
  data() {
    return {}
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {},
  methods: {}
}
</script>
<style>
.app-main-card > div {
  height: 100%;
}
</style>
<style scoped lang="scss">
.home-img {
  width: 100%;
  margin: 0 auto;
  height: 100%;
  text-align: center;
}
.home-img img {
  width: 1000px;
  position: absolute;
  left: 50%;
  top: 50%;
  animation: fallDown 1s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}
@keyframes fallDown {
  from {
    transform: translate(-50%, -800%);
    opacity: 0;
  }
  60% {
    opacity: 0.2;
  }
  to {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
}
</style>
